import { useEffect, useState } from 'react';

import { getAllComicPosts, getComicPost } from 'utils/WebcomicAPI';
import { ComicPost } from 'types/ComicPost';

export default function useComicPosts(id?: string) {
  const [comicPost, setComicPost] = useState<ComicPost>();
  const [comicPosts, setComicPosts] = useState<ComicPost[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAllComicPosts = async () => {
      let allComicPosts = await getAllComicPosts();

      if (!allComicPosts || !allComicPosts.length) {
        setComicPosts([]);
        setIsLoading(false);
        return;
      }

      allComicPosts.sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1));

      setComicPosts(allComicPosts);
      setIsLoading(false);
    };

    const fetchComicPost = async (id: string) => {
      setComicPost(await getComicPost(id));
      setIsLoading(false);
    };

    if (id) {
      fetchComicPost(id);
    } else {
      fetchAllComicPosts();
    }
  }, [id]);

  return {
    comicPost,
    comicPosts,
    isLoading,
  };
}
